const API = process.env.REACT_APP_API_URL;
export const TMDB_IMG = 'https://image.tmdb.org/t/p/w185';

export const getMovieRequest = async () => {
  try {
    const page = Math.floor(Math.random() * 20) + 1;
    const response = await fetch(`${API}/app/random_actors/${page}`, { cache: 'no-store' });
    if (!response.ok) throw new Error('Network response was not ok');
    return await response.json();
  } catch (error) {
    console.error('Error fetching popular actors:', error);
    return null;
  }
};

export const getRandomActor = async (difficulty = 'medium') => {
  try {
    const response = await fetch(`${API}/app/random_actor?difficulty=${difficulty}`, { cache: 'no-store' });
    if (!response.ok) throw new Error('Network response was not ok');
    return await response.json();
  } catch (error) {
    console.error('Error fetching random actor:', error);
    return null;
  }
};

export const getActorDetails = async (id, attempts = 3) => {
  for (let i = 0; i < attempts; i++) {
    try {
      const response = await fetch(`${API}/app/selected_actor/${id}`);
      if (!response.ok) throw new Error('Network response was not ok');
      return await response.json();
    } catch (error) {
      if (i === attempts - 1) {
        console.error('Error fetching actor details:', error);
        return null;
      }
      await new Promise(res => setTimeout(res, 500 * (i + 1)));
    }
  }
};

export const getMoviesByActor = async (id) => {
  try {
    const response = await fetch(`${API}/app/actor_movies/${id}`);
    if (!response.ok) throw new Error('Network response was not ok');
    return await response.json();
  } catch (error) {
    console.error('Error fetching actor movies:', error);
    return null;
  }
};

export const getActorsbyMovie = async (id) => {
  try {
    const response = await fetch(`${API}/app/movie_actors/${id}`);
    if (!response.ok) throw new Error('Network response was not ok');
    return await response.json();
  } catch (error) {
    console.error('Error fetching movie actors:', error);
    return null;
  }
};
